import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-mission-template',
  imports: [],
  templateUrl: './mission-template.component.html'
})
export class MissionTemplateComponent {
  @Input() missionText =
    'Nossa missão é tornar o acesso a imóveis em leilão mais claro, simples e inteligente. Com tecnologia, dados e IA, ajudamos você a analisar oportunidades com mais confiança e clareza. A Casato Brasil oferece ferramentas para apoiar sua decisão em cada etapa da jornada.';
}
